const listData = (state) => {
  return state.listData
}

const listPagination = (state) => {
  return state.pagination
}

const validationMessage = (state) => {
  return state.validationMessage
}

const hasReservations = (state) => {
  return (state.listData)
}

export default {
  listData,
  listPagination,
  validationMessage,
  hasReservations,
}
